import Gift from './Gift'

export default Gift
// eslint-disable-next-line import/export
export * from './Gift'
